import React, { useEffect } from 'react';
import { shape, string, func, array } from 'prop-types';
import { FORM_TYPES } from 'shared/consts';
import { AddNotification } from 'shared/components';
import { useModal } from 'shared/hooks';
import NotificationsByDate from './components/notifications-by-date/NotificationsByDate';
// import Form from './components/form';

const NotificationsRight = ({
  match: {
    params: { startDate, endDate },
  },
  getActiveDayNotifications,
  getInvestorsOptions,
  addNotification,
  investorsOptions,
  activeDayNotifications,
  getPlotsOptions,
  plotsOptions,
  getSettlementsOptions,
  settlementsOptions,
  authorizedUserRole,
  changeStatus,
  getEmployees,
  employees,
}) => {
  const [isModalOpened, showModal, hideModal] = useModal(false);

  useEffect(() => {
    getEmployees();
  }, []);

  useEffect(() => {
    getActiveDayNotifications({ startDate, endDate });
  }, [startDate, endDate]);

  const handleSubmit = async (values, file) => {
    const response = await addNotification(values, file);
    getActiveDayNotifications({ startDate, endDate });
    return response;
  };

  const handleDoneStatus = uuid => {
    const status = {
      status: 'done',
    };
    changeStatus(status, uuid, { startDate, endDate });
  };

  const handleToDoStatus = uuid => {
    const status = {
      status: 'to_do',
    };
    changeStatus(status, uuid, { startDate, endDate });
  };

  return (
    <>
      <AddNotification
        onClose={hideModal}
        onSubmit={handleSubmit}
        opened={isModalOpened}
        type={FORM_TYPES.ADD}
        investorsOptions={investorsOptions}
        getInvestorsOptions={getInvestorsOptions}
        getPlotsOptions={getPlotsOptions}
        plotsOptions={plotsOptions}
        settlementsOptions={settlementsOptions}
        getSettlementsOptions={getSettlementsOptions}
        loggedUserRole={authorizedUserRole}
        employeesOptions={employees}
        // userRole={authorizedUserRole}
        // partnersOptions={partnersOptions}
        // getPartnersOptions={getPartnersOptions}
        // getDdiOptions={getDdiOptions}
        // ddiOptions={ddiOptions}
      />
      <NotificationsByDate
        activeDayNotifications={activeDayNotifications}
        handleOpenModal={showModal}
        handleDoneStatus={handleDoneStatus}
        handleToDoStatus={handleToDoStatus}
      />
    </>
  );
};

NotificationsRight.propTypes = {
  actions: shape({
    deleteInvestor: func.isRequired,
  }).isRequired,
  activeDayNotifications: array.isRequired,
  addNotification: func.isRequired,
  authorizedUserRole: string.isRequired,
  changeStatus: func.isRequired,
  employees: array.isRequired,
  getActiveDayNotifications: func.isRequired,
  getEmployees: func.isRequired,
  getInvestorsOptions: func.isRequired,
  getPlotsOptions: func.isRequired,
  getSettlementsOptions: func.isRequired,
  investors: shape({}).isRequired,
  investorsOptions: func.isRequired,
  match: shape({
    params: shape({
      uuid: string.isRequired,
    }).isRequired,
  }).isRequired,
  plotsOptions: array.isRequired,
  settlementsOptions: array.isRequired,
};

export default NotificationsRight;
